<script>
import AkInputNumber from '@components/v2/input/AkInputNumber';

export default {
  components: {AkInputNumber},
  props: {
    modelValue: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
    },
    validator: {
      type: Object,
      required: false,
      default: undefined,
    },
    submitted: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    min: {
      type: Number,
      required: false,
      default: 0,
    },
    max: {
      type: Number,
      required: false,
      default: 100,
    },
    prefix: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <AkInputNumber
    v-model="currentValue"
    :className="className"
    :disabled="disabled"
    :label="label"
    :max="max"
    :min="min"
    :placeholder="placeholder"
    :submitted="submitted"
    :validator="validator"
    mode="decimal"
    suffix="%"
    :prefix="prefix" />
</template>
